export default "__VITE_ASSET__CiNPlYFr__"